import React from 'react'
import styled, { css } from 'styled-components'

const width = '17'
const height = '16'
const viewBox = '0 0 17 16'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M9.171 16H1.508a.883.883 0 0 1-.883-.883V.883C.625.395 1.02 0 1.508 0h14.234c.488 0 .883.395.883.883v14.234a.883.883 0 0 1-.883.883h-4.077V9.804h2.08l.31-2.415h-2.39V5.848c0-.7.194-1.176 1.196-1.176h1.28v-2.16c-.222-.03-.981-.095-1.864-.095-1.844 0-3.106 1.125-3.106 3.191V7.39H7.086v2.415h2.085V16z"
      key="key-0"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'LogoSocialFacebook'
})
